import { state } from "../state/workspaceStore.js";
import { head } from "../components/common/PageHeader.jsx";
import { btn } from "../components/forms/FormControls.jsx";
import { nodes } from "../components/common/reactHelpers.jsx";
import { esc, money } from "../utils/format.js";
import { applicabilityText } from "../components/coupons/applicability.js";
import { badge } from "../components/common/StatusBadge.jsx";
import { tableViews } from "../components/tables/RecordTable.jsx";
export function coupons() {
  const rows = state.db.coupons.map((c) => ({
    id: c.id,
    name: c.code,
    type: "Coupon",
    coupon: c,
    active: c.active,
    kind: "delete-coupon",
    edit: c.id,
  }));
  for (const a of state.db.couponAliases) {
    const c = state.db.coupons.find((c) => c.id === a.couponId);
    if (c)
      rows.push({
        id: a.code,
        name: a.code,
        type: "Alias → " + c.code,
        coupon: c,
        active: a.active && c.active,
        kind: "delete-alias",
        edit: c.id,
      });
  }
  rows.sort(
    (a, b) =>
      Number(b.active) - Number(a.active) || a.name.localeCompare(b.name),
  );
  return (
    <>
      {head(
        "PRICING",
        "Coupons",
        "Product eligibility and first-order coupon rules.",
        btn("＋ Add New Coupon", 'data-nav="coupon-edit"'),
      )}
      {
        <section className={"card"}>
          <div className={"table-wrap"}>
            <table>
              <thead>
                <tr>
                  <th>{"Code"}</th>
                  <th>{"Type"}</th>
                  <th>{"Discount %"}</th>
                  <th>{"Minimum merchandise"}</th>
                  <th>{"Eligibility"}</th>
                  <th>{"Applicable products"}</th>
                  <th>{"Status"}</th>
                  <th>{"Actions"}</th>
                </tr>
              </thead>
              <tbody>
                {nodes(
                  rows.map((r) => {
                    const c = r.coupon;
                    return (
                      <tr>
                        <td>
                          <b>{esc(r.name)}</b>
                        </td>
                        <td>{esc(r.type)}</td>
                        <td>
                          {c.percent}
                          {"%"}
                        </td>
                        <td>{money(c.minimum)}</td>
                        <td>
                          {c.newOnly ? "New customers only" : "All customers"}
                          {c.stacking ? " · stacking allowed" : ""}
                        </td>
                        <td className={"table-long"}>
                          {esc(applicabilityText(c))}
                        </td>
                        <td>{badge(r.active ? "Active" : "Inactive")}</td>
                        <td>
                          <button
                            className={"text-btn"}
                            data-nav={"coupon-edit"}
                            data-id={esc(r.edit)}
                          >
                            {"View / Edit"}
                          </button>
                          <button
                            className={"text-btn danger"}
                            data-confirm={r.kind}
                            data-id={esc(r.id)}
                          >
                            {"Delete"}
                          </button>
                        </td>
                      </tr>
                    );
                  }),
                ) || (
                  <tr>
                    <td colSpan={"8"} className={"empty"}>
                      {"No saved coupons. Add a coupon to begin."}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      }
    </>
  );
}
export default function CouponsPage({ recordId } = {}) {
  return tableViews(coupons());
}
